// extracted by mini-css-extract-plugin
module.exports = {"xsmall":"375px","small":"750px","medium":"1100px","large":"1350px","xlarge":"1650px","xxlarge":"2000px"};